// src/App.tsx
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Require Auth
import { RequireDealerAuth } from "./components/Auth/RequireDealerAuth";
import { RequireCustomerAuth } from "./components/Auth/RequireCustomerAuth";
// Layouts
import RootLayout from "@/layouts/RootLayout";
import DealersLayout from "@/layouts/DealersLayout";
import SalesPersonLayout from "@/layouts/SalesPersonLayout";
import BdcLayout from "@/layouts/BdcLayout";

// Public Pages
import HomePage from "@/pages/Home/HomePage";
import NotFound from "@/pages/NotFound/NotFound";

// BDC Pages
import BdcPage from "@/pages/Bdc/BdcPage";
import BdcDashboardPage from "@/pages/Bdc/BdcDashboardPage";
import BdcLoginPage from "@/pages/Bdc/BdcLoginPage";
import BdcCallsPage from "@/pages/Bdc/BdcCallsPage";
import BdcAppointmentsPage from "@/pages/Bdc/BdcAppointmentsPage";
import AdminLoginPage from "@/pages/Admin/AdminLoginPage";
import AdminLayout from "@/layouts/AdminLayout";
import AdminDashboardPage from "@/pages/Admin/AdminDashboardPage";

// Customer Pages
import CustomerLayout from "@/layouts/CustomerLayout";
import CustomerLoginPage from "@/pages/Customer/CustomerLoginPage";
import CustomerPortal from "@/pages/Customer/CustomerPortal";
import CustomerDashboard from "@/pages/Customer/CustomerDashboard";
import CustomerVehiclesPage from "@/pages/Customer/CustomerVehiclesPage";
import CustomerVehicleUploadPage from "@/pages/Customer/CustomerVehicleUploadPage";
import CustomerDealsPage from "@/pages/Customer/CustomerDealsPage";
import CustomerDealBuilderPage from "@/pages/Customer/CustomerDealBuilderPage";
import CustomerMarketplacePage from "@/pages/Customer/CustomerMarketplacePage";
import CustomerProfilePage from "@/pages/Customer/CustomerProfilePage";
import CustomerCreditAppPage from "@/pages/Customer/CustomerCreditAppPage";
import CustomerDocumentsPage from "@/pages/Customer/CustomerDocumentsPage";
import CustomerRepairOrdersPage from "@/pages/Customer/CustomerRepairOrdersPage";

// Repair Shop Pages
import RepairShopLocatorPage from "@/pages/RepairShop/RepairShopLocatorPage";
import RepairShopDetailPage from "@/pages/RepairShop/RepairShopDetailPage";
import BookAppointmentPage from "@/pages/RepairShop/BookAppointmentPage";
import RepairOrderDetailPage from "@/pages/Service/RepairOrderDetailPage";

// Auction Pages
import AuctionMarketplacePage from "@/pages/Auction/AuctionMarketplacePage";
import AuctionListingPage from "@/pages/Auction/AuctionListingPage";
import AuctionAccountRequestPage from "@/pages/Auction/AuctionAccountRequestPage";

// Dealers Pages
import DealerDashboardPage from "@/pages/Dealers/DealerDashboardPage";
import DealerSignupPage from "@/pages/Dealers/DealerSignupPage";
import DealersPage from "@/pages/Dealers/DealersPage";
import DealerLoginPage from "@/pages/Dealers/DealerLoginPage";
import DealerInventoryPage from "@/pages/Dealers/DealerInventoryPage";
import DealerFinancePage from "@/pages/Dealers/DealerFinancePage";

// Sales Pages
import SalesPage from "@/pages/Sales/SalesPage";
import SalesLoginPage from "@/pages/Sales/SalesLoginPage";
import SalesLeadsPage from "@/pages/Sales/SalesLeadsPage";
import SalesContractsPage from "@/pages/Sales/SalesContractsPage";
import SalesDashboard from "@/pages/Sales/SalesDashboard";



// Service Pages
import ServiceLoginPage from "@/pages/Service/ServiceLoginPage";
import ServiceLayout from "@/layouts/ServiceLayout";
import ServiceDashboard from "@/pages/Service/ServiceDashbaord";
import ServiceRepairOrdersPage from "@/pages/Service/ServiceRepairOrdersPage";
import ServiceAppointmentsPage from "@/pages/Service/ServiceAppointmentsPage";
import ServiceCreateROPage from "@/pages/Service/ServiceCreateROPage";


// Finance Pages
import FinanceLoginPage from "@/pages/Finance/FinanceLoginPage";
import FinanceLayout from "@/layouts/FinanceLayout";
import FinanceDashboard from "@/pages/Finance/FinanceDashboard";
import BroadcastPage from "@/pages/Sales/BroadcastPage";

// Broadcat
import BroadcastPanel from "@/components/Broadcast/BroadcastPanel";
import PartsLoginPage from "@/pages/Parts/PartsLoginPage";

// Parts
import PartsDashboard from "@/pages/Parts/PartsDashboard";

// Warranty
import WarrantyLoginPage from "@/pages/Warranty/WarrantyLoginPage";
import WarrantyDashboard from "@/pages/Warranty/WarrantyDashboard";
import WarrantyQuoteRequestsPage from "@/pages/Warranty/WarrantyQuoteRequestsPage";
import WarrantySubmitQuotePage from "@/pages/Warranty/WarrantySubmitQuotePage";
import WarrantyMyQuotesPage from "@/pages/Warranty/WarrantyMyQuotesPage";
import WarrantyBillingPage from "@/pages/Warranty/WarrantyBillingPage";


import FinancePage from "@/pages/Finance/FinancePage";

import CustomerPage from "@/pages/Customer/CustomerPage";
import AdminPage from "@/pages/Admin/AdminPage";
import ServicePage from "@/pages/Service/ServicePage";
import PartsPage from "@/pages/Parts/PartsPage";
import WarrantyPage from "@/pages/Warranty/WarrantyPage";
import PartsLayout from "@/layouts/PartsLayout";
import WarrantyLayout from "@/layouts/WarrantyLayout";
import TechnicanLayout from "@/layouts/TechnicianLayout";
import TechnicanDashboard from "@/pages/Technican/TechnicanDashboard";
import MissionPage from "@/pages/Mission/MissionPage";
import AboutUsPage from "@/pages/About/AboutUsPage";
import ContactPage from "@/pages/Contact/ContactPage";
import AuctionLayout from "@/layouts/AuctionLayout";
import AuctionPage from "@/pages/Auction/AuctionPage";
import AuctionDashboardPage from "@/pages/Auction/AuctionDashboardPage";
import VideoPage from "@/pages/Video/VideoPage";
import BlogPage from "@/pages/Blog/BlogPage";
import NewsPage from "@/pages/News/NewsPage";
import InsuranceLoginPage from "@/pages/Insurance/InsuranceLoginPage";
import InsuranceLayout from "@/layouts/InsuranceLayout";
import InsurancePage from "@/pages/Insurance/InsurancePage";
import InsuranceDashboard from "@/pages/Insurance/InsuranceDashboard";
import InsuranceQuoteRequestsPage from "@/pages/Insurance/InsuranceQuoteRequestsPage";
import InsuranceSubmitQuotePage from "@/pages/Insurance/InsuranceSubmitQuotePage";
import InsuranceMyQuotesPage from "@/pages/Insurance/InsuranceMyQuotesPage";
import InsuranceBillingPage from "@/pages/Insurance/InsuranceBillingPage";
import AdminInsurancePage from "@/pages/Admin/AdminInsurancePage";
import AdminBillingPage from "@/pages/Admin/AdminBillingPage";
import AdminWarrantyPage from "@/pages/Admin/AdminWarrantyPage";
import AdminTransportPage from "@/pages/Admin/AdminTransportPage";
import AdminSalvagePage from "@/pages/Admin/AdminSalvagePage";
import AdminFloorPlanPage from "@/pages/Admin/AdminFloorPlanPage";
import AdminPendingDealersPage from "@/pages/Admin/AdminPendingDealersPage";
import MarketplacePage from "@/pages/Marketplace/MarketplacePage";
import IntegrationsPage from "@/pages/Integrations/IntegrationsPage";
import CustomerSignUpPage from "@/pages/Customer/CustomerSignUpPage";
import AutocitymagPage from "@/pages/Marketplace/Autocitymag";
import AfricarsAppPage from "@/pages/Marketplace/AfricarsApp/AfricarsAppPage";
import SalespersonCreatePage from "@/pages/Dealers/SalespersonCreatePage";
import AssistantPage from "@/pages/Assistant/AssistantPage";
import AssistantLayout from "@/layouts/AssistantLayout";
import AssistantLoginPage from "@/pages/Assistant/AssistantLoginPage";
import AssistantDashboardPage from "@/pages/Assistant/AssistantDashboardPage";
import CareersPage from "@/pages/Careers/CareersPage";
import CollisionPage from "@/pages/Collision/CollisionPage";
import CollisionLoginPage from "@/pages/Collision/CollisionLoginPage";
import CollisionDashboard from "@/pages/Collision/CollisionDashboard";
import CollisionLayout from "@/layouts/CollisionLayout";
import LendersPage from "@/pages/Lender/LendersPage";
import LendersLoginPage from "@/pages/Lender/LendersLoginPage";
import LendersDashboardPage from "@/pages/Lender/LendersDashboardPage";
import LendersLayout from "@/layouts/LendersLayout";
import SalesmanagerCreatePage from "./pages/Dealers/SalesmanagerCreatePage";
import FinancemanagerCreatePage from "./pages/Dealers/FinancemanagerCreatePage";
import DealerStaffPage from "./pages/Dealers/DealerStaffPage";
import DealerCustomerPage from "./pages/Dealers/DealerCustomersPage";
import DealerAppointmentsPage from "./pages/Dealers/DealerAppointmentsPage";
import AuctionLoginPage from "./pages/Auction/AuctionLoginPage";
import SalvagePage from "./pages/Salvage/SalvagePage";
import SalvageLoginPage from "./pages/Salvage/SalvageLoginPage";
import SalvageDashboardPage from "./pages/Salvage/SalvageDashboardPage";
import SalvageVehiclesPage from "./pages/Salvage/SalvageVehiclesPage";
import SalvageBidsPage from "./pages/Salvage/SalvageBidsPage";
import SalvageLayout from "./layouts/SalvageLayout";
import TransportPage from "./pages/Transport/TransportPage";
import TransportLoginPage from "./pages/Transport/TransportLoginPage";
import TransportDashboardPage from "./pages/Transport/TransportDashboardPage";
import TransportShipmentsPage from "./pages/Transport/TransportShipmentsPage";
import TransportLayout from "./layouts/TransportLayout";
import FloorPlanLogin from "./pages/FloorPlan/FloorPlanLogin";
import FloorPlanDashboard from "./pages/FloorPlan/FloorPlanDashboard";
import FloorPlanDealersPage from "./pages/FloorPlan/FloorPlanDealersPage";
import FloorPlanLayout from "./layouts/FloorPlanLayout";
import BdcCreatePage from "./pages/Dealers/BdcCreatePage";
import ServiceManagerCreatePage from "./pages/Dealers/ServiceManagerCreatePage";
import { DealerInventoryAddPage } from "./pages/Dealers/DealerInventoryAddPage";
import DealerInventoryEditPage from "./pages/Dealers/DealerInventoryEditPage";
import DealerCreditApps from "./pages/Dealers/DealerCreditApps";
import DealerDealsPage from "./pages/Dealers/DealerDealsPage";
import DealersLeadsPage from "./pages/Dealers/DealersLeadsPage";
import DealersLeadPage from "./pages/Dealers/DealersLeadPage";
import DealerLeadsBuyPage from "./pages/Dealers/DealerLeadsBuyPage";
import DealerDealDeskPage from "./pages/Dealers/DealerDealDeskPage";


export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Public */}
                <Route element={<RootLayout />}>
                    <Route path="/" element={<HomePage />} />
                </Route>

                {/* Admin Group Routes */}
                <Route element={<RootLayout />}>
                    <Route path="/admin/login" element={<AdminLoginPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    {/* investors, lenders, etc. */}
                </Route>
                <Route element={<AdminLayout />}>
                    <Route path="/admin/dashboard"              element={<AdminDashboardPage />} />
                    <Route path="/admin/insurance-companies"    element={<AdminInsurancePage />} />
                    <Route path="/admin/warranty-companies"     element={<AdminWarrantyPage />} />
                    <Route path="/admin/billing"                element={<AdminBillingPage />} />
                    <Route path="/admin/transport-companies"    element={<AdminTransportPage />} />
                    <Route path="/admin/salvage-companies"      element={<AdminSalvagePage />} />
                    <Route path="/admin/floorplan-companies"    element={<AdminFloorPlanPage />} />
                    <Route path="/admin/dealers/pending"        element={<AdminPendingDealersPage />} />
                </Route>

                {/* Assistant Group Routes */}
                <Route element={<RootLayout />}>
                    <Route path="/assistant" element={<AssistantPage />} />
                    <Route path="/assistant/login" element={<AssistantLoginPage />} />
                    
                    {/* assistant, datacollectors, ambassadors. */}
                </Route>
                <Route element={<AssistantLayout />}>
                    <Route path="/assistant/dashboard" element={<AssistantDashboardPage />} />
                    
                    {/* … admin tools */}
                </Route>


                <Route element={<RootLayout />}>
                    <Route path="/auction/" element={<AuctionPage />} />
                    <Route path="/auctions/" element={<AuctionPage />} />
                    <Route path="/auctions/login" element={<AuctionLoginPage />} />
                    {/* investors, lenders, etc. */}
                </Route>
                <Route element={<AuctionLayout />}>
                    <Route path="/auctions/dashboard" element={<AuctionDashboardPage />} />
                    
                    {/* … admin tools */}
                </Route>



                {/* BDC portal */}
                <Route element={<RootLayout />}>
                    <Route path="/bdc" element={<BdcPage />} />
                    <Route path="/bdc/login" element={<BdcLoginPage />} />
                </Route>
                <Route element={<BdcLayout />}>
                    <Route path="/bdc/dashboard" element={<BdcDashboardPage />} />
                    <Route path="/bdc/calls" element={<BdcCallsPage />} />
                    <Route path="/bdc/appointments" element={<BdcAppointmentsPage />} />
                </Route>




                {/* Service portal */}
                <Route element={<RootLayout />}>
                    <Route path="/collision" element={<CollisionPage />} />
                    <Route path="/collision/login" element={<CollisionLoginPage />} />
                </Route>
                <Route element={<CollisionLayout />}>
                    <Route path="/collision/dashboard"          element={<CollisionDashboard />} />
                    <Route path="/collision/repair-orders"      element={<ServiceRepairOrdersPage />} />
                    <Route path="/collision/repair-orders/:roId" element={<RepairOrderDetailPage />} />
                    <Route path="/collision/appointments"       element={<ServiceAppointmentsPage />} />
                </Route>


                {/* Customer — public (login / signup) */}
                <Route element={<RootLayout />}>
                    <Route path="/customer" element={<CustomerPage />} />
                    <Route path="/customer/login" element={<CustomerLoginPage />} />
                    <Route path="/customer/signup" element={<CustomerSignUpPage />} />
                </Route>

                {/* Customer — protected portal */}
                <Route element={<CustomerLayout />}>
                    <Route
                        path="/customer/dashboard"
                        element={<RequireCustomerAuth><CustomerDashboard /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/portal"
                        element={<RequireCustomerAuth><CustomerDashboard /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/vehicles"
                        element={<RequireCustomerAuth><CustomerVehiclesPage /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/vehicles/upload"
                        element={<RequireCustomerAuth><CustomerVehicleUploadPage /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/marketplace"
                        element={<RequireCustomerAuth><CustomerMarketplacePage /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/deals"
                        element={<RequireCustomerAuth><CustomerDealsPage /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/deal-builder"
                        element={<RequireCustomerAuth><CustomerDealBuilderPage /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/profile"
                        element={<RequireCustomerAuth><CustomerProfilePage /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/credit-app"
                        element={<RequireCustomerAuth><CustomerCreditAppPage /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/documents"
                        element={<RequireCustomerAuth><CustomerDocumentsPage /></RequireCustomerAuth>}
                    />
                    <Route
                        path="/customer/repair-orders"
                        element={<RequireCustomerAuth><CustomerRepairOrdersPage /></RequireCustomerAuth>}
                    />
                </Route>

                {/* Repair Shops — public */}
                <Route element={<RootLayout />}>
                    <Route path="/repair-shops"            element={<RepairShopLocatorPage />} />
                    <Route path="/repair-shops/:shopId"    element={<RepairShopDetailPage />} />
                    <Route path="/repair-shops/:shopId/book" element={<BookAppointmentPage />} />
                </Route>

                {/* Repair Order Detail — staff portal */}
                <Route element={<ServiceLayout />}>
                    <Route path="/service/repair-orders/:roId" element={<RepairOrderDetailPage />} />
                </Route>

                {/* Auction — public + customer */}
                <Route element={<RootLayout />}>
                    <Route path="/auctions/marketplace"       element={<AuctionMarketplacePage />} />
                    <Route path="/auctions/listings/:id"      element={<AuctionListingPage />} />
                    <Route path="/auctions/request-account"   element={<AuctionAccountRequestPage />} />
                </Route>


                {/* Dealer portal */}


                <Route element={<RootLayout />}>
                    <Route path="/dealer" element={<DealersPage />} />
                    <Route path="/dealer/login" element={<DealerLoginPage />} />
                    <Route path="/dealer/signup" element={<DealerSignupPage />} />
                    {/* investors, lenders, etc. */}
                </Route>

                <Route element={<DealersLayout />}>
                    
                  
                    <Route
                        path="/dealer/appointments"
                        element={
                            <RequireDealerAuth>
                                <DealerAppointmentsPage />
                            </RequireDealerAuth>
                        }
                    />

                   

                    <Route
                        path="/dealer/bdc-create"
                        element={
                            <RequireDealerAuth>
                                <BdcCreatePage />
                            </RequireDealerAuth>
                        }
                    />

                    
                    <Route
                        path="/dealer/credit-apps"
                        element={
                            <RequireDealerAuth>
                                <DealerCreditApps />
                            </RequireDealerAuth>
                        }
                    />
                    <Route
                        path="/dealer/customers"
                        element={
                            <RequireDealerAuth>
                                <DealerCustomerPage />
                            </RequireDealerAuth>
                        }
                    />

                    <Route
                        path="/dealer/dashboard"
                        element={
                            <RequireDealerAuth>
                                <DealerDashboardPage />
                            </RequireDealerAuth>
                        }
                    />

                    <Route
                        path="/dealer/deals"
                        element={
                            <RequireDealerAuth>
                                <DealerDealsPage />
                            </RequireDealerAuth>
                        }
                    />

                    <Route
                        path="/dealer/dealdesk"
                        element={
                            <RequireDealerAuth>
                                <DealerDealDeskPage />
                            </RequireDealerAuth>
                        }
                    />

                    <Route
                        path="/dealer/finance"
                        element={
                            <RequireDealerAuth>
                                <DealerFinancePage />
                            </RequireDealerAuth>
                        }
                    />
                    <Route
                        path="/dealer/financemanager-create"
                        element={
                            <RequireDealerAuth>
                                <FinancemanagerCreatePage />
                            </RequireDealerAuth>
                        }
                    />
                    <Route
                        path="/dealer/inventory"
                        element={
                            <RequireDealerAuth>
                                <DealerInventoryPage />
                            </RequireDealerAuth>
                        }
                    />
                    <Route
                        path="/dealer/inventory/add"
                        element={
                            <RequireDealerAuth>
                                <DealerInventoryAddPage />
                            </RequireDealerAuth>
                        }
                    />
                    <Route
                        path="/dealer/inventory/edit/:vid"
                        element={
                            <RequireDealerAuth>
                                <DealerInventoryEditPage />
                            </RequireDealerAuth>
                        }
                    />

                    <Route
                        path="/dealer/lead"
                        element={
                            <RequireDealerAuth>
                                <DealersLeadPage />
                            </RequireDealerAuth>
                        }
                    />

                    <Route
                        path="/dealer/leads"
                        element={
                            <RequireDealerAuth>
                                <DealersLeadsPage />
                            </RequireDealerAuth>
                        }
                    />

                    <Route
                        path="/dealer/leads/buy"
                        element={
                            <RequireDealerAuth>
                                <DealerLeadsBuyPage />
                            </RequireDealerAuth>
                        }
                    />
                    
                    <Route
                        path="/dealer/salesperson-create"
                        element={
                            <RequireDealerAuth>
                                <SalespersonCreatePage />
                            </RequireDealerAuth>
                        }
                    />
                    <Route
                        path="/dealer/salesmanager-create"
                        element={
                            <RequireDealerAuth>
                                <SalesmanagerCreatePage />
                            </RequireDealerAuth>
                        }
                    />
                   
                    <Route
                        path="/dealer/servicemanager-create"
                        element={
                            <RequireDealerAuth>
                                <ServiceManagerCreatePage />
                            </RequireDealerAuth>
                        }
                    />
                    <Route
                        path="/dealer/staff"
                        element={
                            <RequireDealerAuth>
                                <DealerStaffPage />
                            </RequireDealerAuth>
                        }
                    />
                   

                </Route>



                {/* Insurance Routes & Layout */}
                <Route element={<RootLayout />}>
                    <Route path="/insurance" element={<InsurancePage />} />
                    <Route path="/insurance/login" element={<InsuranceLoginPage />} />
                </Route>
                <Route element={<InsuranceLayout />}>
                    <Route path="/insurance/dashboard"                         element={<InsuranceDashboard />} />
                    <Route path="/insurance/quote-requests"                    element={<InsuranceQuoteRequestsPage />} />
                    <Route path="/insurance/quote-requests/:requestId/submit"  element={<InsuranceSubmitQuotePage />} />
                    <Route path="/insurance/my-quotes"                         element={<InsuranceMyQuotesPage />} />
                    <Route path="/insurance/billing"                           element={<InsuranceBillingPage />} />
                </Route>

                
 

                <Route element={<RootLayout />}>
                    <Route path="/finance/" element={<FinancePage />} />
                    <Route path="/finance/login" element={<FinanceLoginPage />} />
                    {/* investors, lenders, etc. */}
                </Route>
                <Route element={<FinanceLayout />}>
                    <Route path="/finance/dashboard" element={<FinanceDashboard />} />
                    {/* investors, lenders, etc. */}
                </Route>

                <Route element={<RootLayout />}>
                    <Route path="/lenders/" element={<LendersPage />} />
                    <Route path="/lenders/login" element={<LendersLoginPage />} />
                    {/* investors, lenders, etc. */}
                </Route>
                <Route element={<LendersLayout />}>
                    <Route path="/lenders/dashboard" element={<LendersDashboardPage />} />
                    {/* investors, lenders, etc. */}
                </Route>


                {/* Market Places */}
                <Route element={<RootLayout />}>
                    <Route path="/marketplaces" element={<MarketplacePage />} />
                    <Route path="/marketplaces/autocitymag" element={<AutocitymagPage />} />
                    <Route path="/marketplaces/africars.app" element={<AfricarsAppPage />} />
                    
                    {/* investors, lenders, etc. */}
                </Route>


                {/* parts deliver, routes maps clerk */}
                <Route element={<RootLayout />}>
                    <Route path="/parts" element={<PartsPage />} />
                    <Route path="/parts/login" element={<PartsLoginPage />} />
                </Route>
                <Route element={<PartsLayout />}>
                    <Route path="/parts/dashboard"           element={<PartsDashboard />} />
                    <Route path="/parts/repair-orders"       element={<ServiceRepairOrdersPage />} />
                    <Route path="/parts/repair-orders/:roId" element={<RepairOrderDetailPage />} />
                </Route>


                {/* Salvage portal */}
                <Route element={<RootLayout />}>
                    <Route path="/salvage" element={<SalvagePage />} />
                    <Route path="/salvage/login" element={<SalvageLoginPage />} />
                </Route>
                <Route element={<SalvageLayout />}>
                    <Route path="/salvage/dashboard" element={<SalvageDashboardPage />} />
                    <Route path="/salvage/vehicles"  element={<SalvageVehiclesPage />} />
                    <Route path="/salvage/bids"      element={<SalvageBidsPage />} />
                </Route>

                {/* Sales portal */}
                <Route element={<RootLayout />}>
                    <Route path="/sales" element={<SalesPage />} />
                    <Route path="/sales/login" element={<SalesLoginPage />} />
                </Route>
                <Route element={<SalesPersonLayout />}>
                    <Route path="/sales/dashboard" element={<SalesDashboard />} />
                    <Route path="/sales/leads" element={<SalesLeadsPage />} />
                    <Route path="/sales/contracts" element={<SalesContractsPage />} />
                    <Route path="/sales/broadcast" element={<BroadcastPanel />} />
                    <Route path="/sales/broadcast-test" element={<BroadcastPage />} />
                </Route>

         

                {/* Service portal */}
                <Route element={<RootLayout />}>
                    <Route path="/service" element={<ServicePage />} />
                    <Route path="/service/login" element={<ServiceLoginPage />} />
                </Route>
                <Route element={<ServiceLayout />}>
                    <Route path="/service/dashboard"              element={<ServiceDashboard />} />
                    <Route path="/service/repair-orders"          element={<ServiceRepairOrdersPage />} />
                    <Route path="/service/repair-orders/new"      element={<ServiceCreateROPage />} />
                    <Route path="/service/appointments"           element={<ServiceAppointmentsPage />} />
                    {/* service advisor, technician */}
                </Route>


                {/* Technician Dashboard */}
                <Route element={<RootLayout />}>
                    <Route path="/technican" element={<ServicePage />} />
                    <Route path="/technican/login" element={<ServiceLoginPage />} />
                </Route>
                <Route element={<TechnicanLayout />}>
                    <Route path="/technican/dashboard"     element={<TechnicanDashboard />} />
                    <Route path="/technican/repair-orders" element={<ServiceRepairOrdersPage />} />
                    <Route path="/technican/repair-orders/:roId" element={<RepairOrderDetailPage />} />
                    <Route path="/technican/appointments"  element={<ServiceAppointmentsPage />} />
                </Route>


                {/* Transporter Dashboard */}
                <Route element={<RootLayout />}>
                    <Route path="/transport" element={<TransportPage />} />
                    <Route path="/transport/login" element={<TransportLoginPage />} />
                </Route>
                <Route element={<TransportLayout />}>
                    <Route path="/transport/dashboard"  element={<TransportDashboardPage />} />
                    <Route path="/transport/shipments"  element={<TransportShipmentsPage />} />
                </Route>


                {/* Parts Dashboard */}
                {/* Parts Driver Dashboard */}
              


                {/* Warranty */}
                <Route element={<RootLayout />}>
                    <Route path="/warranty" element={<WarrantyPage />} />
                    <Route path="/warranty/login" element={<WarrantyLoginPage />} />
                </Route>
                <Route element={<WarrantyLayout />}>
                    <Route path="/warranty/dashboard"                              element={<WarrantyDashboard />} />
                    <Route path="/warranty/quote-requests"                         element={<WarrantyQuoteRequestsPage />} />
                    <Route path="/warranty/quote-requests/:requestId/submit"       element={<WarrantySubmitQuotePage />} />
                    <Route path="/warranty/my-quotes"                              element={<WarrantyMyQuotesPage />} />
                    <Route path="/warranty/billing"                                element={<WarrantyBillingPage />} />
                </Route>                 


                {/* Floor Plan portal */}
                <Route element={<RootLayout />}>
                    <Route path="/floorplan/login" element={<FloorPlanLogin />} />
                </Route>
                <Route element={<FloorPlanLayout />}>
                    <Route path="/floorplan/dashboard" element={<FloorPlanDashboard />} />
                    <Route path="/floorplan/dealers"   element={<FloorPlanDealersPage />} />
                </Route>


                 {/* Deatailer Dashboard */}
                 {/* 3rd party like zephZeal, detailer */}


                 {/* Porter portal */}
                 {/* take customer home maps routes tracking notes */}
                 {/* has marketing opportunity to communicate to customer about checkin times and time of completion and return pickup */}

                <Route element={<RootLayout />}>
                    <Route path="/about" element={<AboutUsPage />} />
                    <Route path="/blog" element={<BlogPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/careers" element={<CareersPage title={"Careers"} />} />
                    <Route path="/integrations" element={<IntegrationsPage />} />
                    <Route path="/news" element={<NewsPage />} />
                    <Route path="/mission" element={<MissionPage />} />
                    <Route path="/video" element={<VideoPage />} />
                </Route>

                {/* Catch-all */}
                <Route path="*" element={<NotFound />} />

            </Routes>
        </BrowserRouter>
    );
}
